import * as React from 'react';

import { colors } from '~src/theme/colors';
import { fontStyles } from '~src/theme/fontStyles';

interface InputErrorProps {
  dataTest?: string;
  isSoftError?: boolean;
}

export const InputError: React.FC<React.PropsWithChildren<InputErrorProps>> = ({
  children,
  dataTest,
  isSoftError,
}) => {
  return (
    <div data-test={dataTest} css={styles.error(isSoftError)}>
      {children}
    </div>
  );
};

const styles = {
  error: (isSoftError?: boolean) => ({
    color: isSoftError ? colors.darkOrange : colors.error35,
    ...fontStyles.px14_20,
    marginTop: '6px',
  }),
};
